import { colors } from '@libs/ui';
// Deep icon import (not the `@mui/icons-material` barrel), which trips EMFILE under vitest.
import Check from '@mui/icons-material/Check';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import type { Space } from '../../../models';

interface SpaceMenuItemProps {
  space: Space;
  isSelected: boolean;
  onClick: () => void;
}

function SpaceMenuItem(props: SpaceMenuItemProps) {
  const { space, isSelected, onClick } = props;

  return (
    <ListItemButton
      id={`global-space-switch-item-${space.spaceCode}`}
      disableRipple
      selected={isSelected}
      onClick={onClick}
      sx={{
        '&.Mui-selected': { backgroundColor: colors.seaGreen5 },
        '&.Mui-selected:hover': { backgroundColor: colors.seaGreen4 },
      }}
    >
      <ListItemIcon sx={{ minWidth: '28px', color: colors.seaGreen }}>
        {isSelected && <Check fontSize="small" />}
      </ListItemIcon>
      <ListItemText
        primary={space.spaceName}
        slotProps={{ primary: { sx: { fontSize: '12px', fontWeight: isSelected ? 700 : 400 } } }}
      />
    </ListItemButton>
  );
}

export { SpaceMenuItem };
